import { Divider, Flex, Box, Image, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import IBridgedERC721Artifacts from "../artifacts/contracts/interfaces/IBridgedERC721.sol/IBridgedERC721.json";

import logo from "../assets/logo.png";
import lz from "../assets/lz.jpeg";
import { useEffect, useState } from "react";

import {
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    Button
} from '@chakra-ui/react'
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";

function Dashboard () {
    const [ tokenId , settokenId] = useState();
    const { account, library, chainId } = useWeb3React();


    const nftAddr = {
        4: "0xE7699383D286253B09aE72E550Fa4Bb03DC75Ab8",
        421611: "0x9F148AcA2335c031632264097F140448A531e2bD",
    }

    const mintToken = async () => {
        if(library && account) {
            console.log(tokenId);
            const web3 = new Web3(library.currentProvider);
            const nft = new web3.eth.Contract(IBridgedERC721Artifacts.abi, nftAddr[chainId]);

            // const tx = await nft.methods.safeMint(account, parseInt(tokenId)).send({
            //     from: account
            // });
            // console.log(tx);
            // verify non-ownership
            // const owner = await nft.methods.ownerOf(parseInt(tokenId)).call();
            const doesExist = await nft.methods.exists(parseInt(tokenId)).call();
            console.log(doesExist);
            // console.log(owner);
            if(!doesExist) {
                // mint into existence

                const tx = await nft.methods.safeMint(account, parseInt(tokenId)).send({
                    from: account
                });
                console.log(tx);
            } else {
                // 
                alert("This MEGH NFT already been claimed, Kindly try again with another token id!!");
            }
        } else {
            alert("Please connect wallet");
        }
    }
   
    return (
        <Flex
            p="30"
            mt="15"
            flexDir="column"
            overflow="auto"
            boxShadow="lg"
            // borderRadius="18"
            alignItems="center"
            flex ="1"
            alignContent="space-between"
        >
            <VStack>
            <Image src={logo} w="30vw" />
                <Divider />
                <Heading mt="25" color="brand.primary" as="h1" size="lg">Omnichain NFT bridge</Heading>
            </VStack>

            <Box mt="2%" mb="10px">Try minting a MEGH ~ MultiChain ETH Global Hackers</Box>
            
            <Box mb="12px">Select your favorite number as your TokenId 👇🏻</Box>
            <HStack >
            
                <NumberInput onChange={(e)=>settokenId(e)} value={tokenId}>
                    <NumberInputField placeholder="Enter a token id" />
                    <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                    </NumberInputStepper>
                </NumberInput>
                <Button ml="12px" onClick = {mintToken} bgColor="brand.primary" color="white">Mint a MEGH</Button>

                {/* <Text> After minting, you can try bridging it!</Text> */}
            </HStack>
            <VStack h="100%" justifyContent="flex-end">
                <Heading mt="25" color="black" size="sm">ETHGlobals's NFTHack 2022</Heading>
                <Heading mt="25" color="black" size="sm">Supports Rinkeby and Arbitrum for now!</Heading>
                <HStack >
                    <Text>Powered by</Text>
                    <Image w="36px" src={lz} />
                </HStack>
            </VStack>
        </Flex>
    );
}

export default Dashboard;